export default {
  lines: null,
  selected: null,

  showLineLabels: true,
  showArrowLabels: true
}
